import CommercialUserTable from "./page/CommercialUserTable";


const CommercialUser: React.FC = () => {
  return (
    <>
      <CommercialUserTable />
    </>
  );
};
export default CommercialUser;
